<template>
  <div class="pointer">
    <div class="h4 mt-5 mb-5">Featured Promotions</div>
    <v-card
      max-width="98%"
      @click="on_go_to_promotion(promotion)"
      class="bgt-1x ml-4 mr-2 elevation-5 mt-4"
      shaped
      v-for="(promotion, index) in promotions"
      :key="index"
    >
      <v-card-actions>
        <div class="text-left">
          <div
            style="max-width: 150px; font-size: 14px"
            class="font-weight-medium text-left text-truncate"
            v-html="promotion.business.name"
          ></div>
          <div
            class="body-2 grey--text text--darken-1 text-truncate"
            style="max-width: 150px"
            v-html="promotion.title"
          ></div>
        </div>

        <v-avatar tile color="blue">
          <v-img
            :src="'https://picsum.photos/510/300?random'"
            height="50px"
          ></v-img>
        </v-avatar>
      </v-card-actions>
      <v-img
        :src="'https://picsum.photos/510/300?random'"
        class="white--text text-left align-end h6 pa-0 pl-2"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        height="150px"
      >
        <v-card-title
          style="
            max-width: 200px;
            height: 25px;
            font-size: 14px;
            text-align: left;
            justify-content: left;
          "
          class="pa-0 font-weight-medium d-inline-block text-truncate"
          v-html="
            'Ends 20/05/2020 <small class=\'red--text black\'>(2 days left)</small>'
          "
        ></v-card-title>
      </v-img>
    </v-card>
  </div>
</template>

<script>
import ServerClient from "./../lib/ServerClient";

export default {
  name: "FeaturedSidePromotions",
  props: {
    page: {
      type: String,
      required: true
    },
    section: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      promotions: [],
    };
  },
  methods: {
    on_go_to_promotion(promotion) {
      var user = ServerClient.Login.get_logged_in_user();
      //recored that a featured promotion has been clicked on
      //from a certain page for admin purposes
      //then go to the promtion
      ServerClient.Promotions.record_clicked_featured_promotion(
        {
          promotion_id: promotion.id,
          user_id: user == null ? 0 : user.id,
          page: this.page,
          section: this.section
        },
        (res) => {
          this.$router.push("/promotions/" + promotion.id);
        },
        (errors) => {
          console.log("FeaturedSidePromotions: Navigating to promotions error ", promotion);
        }
      );
    },
  },
  mounted() {
    //get data from the server
    ServerClient.Promotions.get_featured_promotions(
      {},
      (res) => {
        this.promotions = res;
      },
      (errors) => {
        console.log("FeaturedSidePromotions: Loading featured promotions error ", errors);
      }
    );
  },
};
</script>